// extracted by mini-css-extract-plugin
export default {"container":"OnevocaCheckBoxContainer_container__BItGL","checkBoxContainer":"OnevocaCheckBoxContainer_checkBoxContainer__ukLqE"};